import { render, staticRenderFns } from "./BasicBlock.vue?vue&type=template&id=816a4d12"
import script from "./BasicBlock.vue?vue&type=script&lang=ts"
export * from "./BasicBlock.vue?vue&type=script&lang=ts"
import style0 from "./BasicBlock.vue?vue&type=style&index=0&id=816a4d12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports